// extracted by mini-css-extract-plugin
export var dividerLine = "_8g-3";
export var itemImage = "_8g-9";
export var lightDivider = "_8g-4";
export var modalContent = "_8g-5";
export var modalContentCompact = "_8g-6";
export var productCard = "_8g-a";
export var productImage = "_8g-b";
export var productImageCompact = "_8g-7";
export var productImagePlaceholder = "_8g-c";
export var productImagePlaceholderCompact = "_8g-8";
export var progressBarBackground = "_8g-1";
export var progressBarContainer = "_8g-0";
export var progressBarFill = "_8g-2";